<template>
  <div class="m-view-switcher">
    <div class="m-view-switcher__container">
      <div class="m-view-switcher__view-switcher" ref="view-switcher" v-if="views">
        <VButton
          v-for="(view, slotName, index) in views"
          type="outline-1"
          :class="{ 'm-view-switcher__button--selected': slotName === activeSlotName }"
          class="m-view-switcher__button"
          :key="slotName"
          :grouping="determineGrouping(index)"
          size="base"
          href="#"
          :data-id="slotName"
          :ref="`view-switcher-${slotName}`"
          @click.native="selectView(slotName)"
          :data-ec="ec"
          :data-et="`viewswitcher_${slotName.toLowerCase()}`">
            <FontIcon class="m-view-switcher__svg" :name="view.icon" v-if="view.icon" />
            <span>{{ view.title }}</span>
        </VButton>
      </div>
    </div>
    <div class="m-view-switcher__content">
      <div v-for="(slot, name) in $slots" :key="name" v-show="activeSlotName === name">
        <slot :name="name" />
      </div>
    </div>
  </div>
</template>
<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import FontIcon from '@/components/Icon.vue';

export default {
  name: 'VViewSwitcher',
  components: {
    VButton,
    FontIcon,
  },
  data() {
    return {
      views: [],
      activeSlotName: null,
    };
  },
  props: {
    ec: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.views = Object.keys(this.$slots).reduce((result, slotName) => {
      const slot = this.$slots[slotName][0];
      result[slotName] = slot.data.attrs; // eslint-disable-line no-param-reassign
      return result;
    }, {});
    this.activeSlotName = Object.keys(this.$slots)[0]; // eslint-disable-line
  },
  methods: {
    selectView(selectedSlotName) {
      this.activeSlotName = selectedSlotName;
      this.$bus.$emit('switchedView', selectedSlotName);
    },
    determineGrouping(index) {
      if (index === 0) {
        return 'left';
      } else if (index === (Object.keys(this.views).length - 1)) {
        return 'right';
      }
      return 'middle';
    },
  },
};
</script>

<style scoped>
.m-view-switcher__container {
  height: 50px;
  margin-bottom: -3px;
  width: 100%;
  display: inline;
}

.m-view-switcher__view-switcher {
  white-space: nowrap;
  display: inline-block;
  padding-bottom: 15px;
  position: relative;
}

.m-view-switcher__button--selected {
  background: #00abe8;
  border-color: #00abe8;
  color: #fff;
}

@media (max-width: 463px) {
  .m-view-switcher__view-switcher {
    width: 100%;
  }
  .m-view-switcher__button {
    width: 50%;
    text-align: center;
  }
  .m-view-switcher__svg {
    float: none !important;
    vertical-align: middle;
  }
  .m-view-switcher__title {
    vertical-align: middle;
  }
}
</style>
